module.exports = __webpack_public_path__ + "img/5-3.bc1606f3.svg";